<template>
  <div>
    <v-select
      v-model="selected"
      :filterable="false"
      :label="fromApprover ? 'displayName' : 'userName'"
      :value="fromApprover ? 'employeeId' : 'apmId'"
      :options="userlist"
      :disabled="disabled"
      :append-to-body="appendToBody"
      :placeholder="placeholder"
      :class="[customClass, 'userControlDropdown', disabled && 'disabled']"
      @search="onSearch"
      @input="handleChange">
      <template #no-options="noOptionSlotProps">
        <template v-if="noOptionSlotProps && noOptionSlotProps.searching">
          <em class="dropdown-no-options">No results found</em>
        </template>
        <em v-else class="dropdown-no-options">No Options</em>
      </template>
      <template
        v-if="fromApprover"
        #selected-option="{ displayName, employeeId }">
        <div>
          <strong>{{ displayName }}</strong>
          {{ employeeId }}
        </div>
      </template>
      <template v-else #selected-option="{ userName, apmId }">
        <div>
          <strong>{{ userName }}</strong>
          <span v-if="apmId">({{ apmId }})</span>
        </div>
      </template>
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes"></span>
      </template>
    </v-select>
    <span v-if="hasError" class="error">Required</span>
    <span v-if="errorMsg" class="error">{{ errorMsg }}</span>
  </div>
</template>

<script>
// Utilities
import AxiosFetch from "@/utils/axios";
import {
  debounce,
  getMsalToken,
  getMsalAccessToken,
  getMsalIdToken,
} from "@/utils/helpers";

// Importing the User Actions
import { userActions } from "@/actions";

// Constants
import { azureActiveDirectoryGroups } from "@/config/constant";

import vSelect from "vue-select";

export default {
  name: "UserControl",
  components: {
    vSelect,
  },
  props: {
    value: { type: String, default: "" },
    label: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: "" },
    hasError: { type: Boolean, default: false },
    customClass: { type: String, default: "" },
    fromApprover: { type: Boolean, default: true },
    errorMsg: { type: String, default: "" },
    userName: { type: String, default: "" },
    appendToBody: { type: Boolean, default: false },
  },
  data: () => {
    return {
      userlist: [],
      selected: null,
    };
  },
  async mounted() {
    if (this.value) {
      this.userlist = this.fromApprover
        ? [{ employeeId: this.value, displayName: this.label }]
        : [{ apmId: this.value, userName: this.label }];
      this.selected = this.fromApprover
        ? { employeeId: this.value, displayName: this.label }
        : { apmId: this.value, userName: this.label };
    }
    if (this.userName) {
      let employeeName = this.userName;
      this.onSearch(employeeName, () => false, true);
    }
  },

  methods: {
    onSearch(search, loading, fromMounted = false) {
      if (search.length >= 3) {
        loading(true);
        this.search(search, loading, this, fromMounted);
      }
    },
    search: debounce(async function (search, loading, vm, fromMounted = false) {
      if (this.fromApprover) {
        const msalToken = await getMsalToken(vm);
        const opts = userActions.getUserLists(
          search,
          `Bearer ${await getMsalIdToken(this)}`,
          `Bearer ${await getMsalAccessToken(this)}`
        );
        const {
          data: { value },
        } = await AxiosFetch(opts);
        this.userlist = value;
        if (this.userName) {
          this.userlist = [
            {
              employeeId: value[0]?.employeeId,
              displayName: value[0]?.displayName,
            },
          ];
          if (fromMounted) {
            this.selected = {
              employeeId: value[0]?.employeeId,
              displayName: value[0]?.displayName,
            };
          }
        }
        loading(false);
      } else {
        const opts = userActions.getUserListFromAzureAdByEmployeeId(
          search,
          azureActiveDirectoryGroups.azureAdForWaiverGamAccess
        );
        const {
          data: { users },
        } = await AxiosFetch(opts);
        this.userlist = users;
        loading(false);
      }
    }, 350),
    handleChange(val) {
      this.$emit("input", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  color: red;
  font-size: 12px;
}
</style>
<style lang="scss">
.userControlDropdown {
  strong {
    font-family: "Maersk Headline";
    font-size: 14px;
  }
  .vs__dropdown-toggle,
  .vs__dropdown-menu {
    overflow-y: auto;
    height: auto;
  }
  .vs__search::placeholder,
  .vs__search,
  .vs__search:focus,
  .vs--single .vs__selected,
  .vs__selected {
    font-size: 14px;
  }
  .vs__dropdown-option {
    white-space: normal;
    padding: 10px 5px;
  }
  .vs__selected-options {
    display: contents;
  }
  .vs__clear {
    position: absolute;
    right: 17px;
    display: block;
    z-index: 10;

    &:hover {
      cursor: pointer;
    }
  }
  .vs__open-indicator {
    position: absolute;
    right: 8px;
    display: block;
    z-index: 10;

    &:hover {
      cursor: pointer;
    }
  }
}
.disabled {
  .vs__selected,
  .vs__search,
  .vs__search::placeholder {
    color: rgb(58, 58, 58);
  }
}
</style>
